import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Legal from "@/pages/Legal";
import VoiceSubmit from "@/pages/VoiceSubmit";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import ResetPassword from "@/pages/admin/ResetPassword";
import CookieBanner from "@/components/site/CookieBanner";

function LenisManager() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, [location.pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center font-head text-[var(--mf-grey)]">Lädt …</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <LenisManager />
          <Toaster position="top-right" richColors />
          <CookieBanner />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/impressum" element={<Legal type="impressum" />} />
            <Route path="/datenschutz" element={<Legal type="datenschutz" />} />
            <Route path="/agb" element={<Legal type="agb" />} />
            <Route path="/stimme/:token" element={<VoiceSubmit />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
